// Offer What You Get Component
// Displays the "What you get" section of an offer card

import { OFFERS } from "./offers-config.ts";
import type { DeliverableItem } from "./offers-config.ts";

class OfferWhatYouGet extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  private createCheckIcon(color: string): string {
    return `
      <svg class="w-5 h-5 text-${color} mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clip-rule="evenodd" />
      </svg>
    `;
  }

  private renderItem(item: DeliverableItem, color: string): string {
    const subitemsHtml = item.subitems
      ? `
      <ul class="ml-4 mt-1 space-y-1 text-slate-600">
        ${
        item.subitems.map((subitem) =>
          `<li><span data-en="${subitem.en}" data-lv="${subitem.lv}" data-it="${subitem.it}">${subitem.en}</span></li>`
        ).join("\n")
      }
      </ul>
    `
      : "";

    return `
      <li class="flex items-start gap-3">
        ${this.createCheckIcon(color)}
        <div>
          <div class="text-slate-600">
            <span data-en="${item.text.en}" data-lv="${item.text.lv}" data-it="${item.text.it}">
              ${item.text.en}
            </span>
          </div>
          ${subitemsHtml}
        </div>
      </li>
    `;
  }

  private render() {
    const offerId = this.getAttribute("offer-id");
    const color = this.getAttribute("color") || "blue-600";

    if (!offerId) {
      console.error("OfferWhatYouGet: offer-id attribute is required");
      return;
    }

    const offer = OFFERS.find((o) => o.id === offerId);
    if (!offer) {
      console.error(`OfferWhatYouGet: offer with id "${offerId}" not found`);
      return;
    }

    const itemsHtml = offer.whatYouGet.map((item) => this.renderItem(item, color)).join("\n");

    this.innerHTML = `
      <ul class="space-y-3 mb-4">
        ${itemsHtml}
      </ul>
    `;
  }
}

customElements.define("offer-what-you-get", OfferWhatYouGet);

export { OfferWhatYouGet };

